export default {
  title: "App"
};
